module.exports = __webpack_public_path__ + "static/img/cMRI2.e2c5c4ad.png";